import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { DevSettings } from '../support/DevSettings';

export const useDevSettings = () => {
    const devSettings = useInstance(DevSettings);
    useSubscription(() => devSettings);
    return devSettings;
};
